import React, { Fragment } from 'react'; 
import { NavLink } from 'react-router-dom';

const Error401Page = () => {
    return (
        <Fragment>
            <div className="container-fluid px-lg-1 px-xl-3">
                <div className="page-breadcrumb">
                    <ul className="breadcrumb">
                        <li className="breadcrumb-item">
                            <NavLink to="/home">Principal</NavLink>
                        </li>
                        <li className="breadcrumb-item">
                            <NavLink to="/home">Error 401</NavLink>
                        </li>
                    </ul>
                </div>
                <div className="page-header">
                    <h1 className="page-heading">Error 401 - Acceso No Autorizado</h1>
                </div>
                <section>
                    <div className="card mb-4">
                        <div className="card-header">
                            <div className="card-heading">
                                <span>Acceso Denegado</span>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="text-center py-5">
                                <i className="fas fa-exclamation-circle fa-3x text-warning mb-4"></i>
                                <h2 className="h4 mb-4">No tienes permisos para acceder a esta página</h2>
                                <p className="text-muted mb-4">
                                    Lo sentimos, pero no tienes los permisos necesarios para acceder a este recurso. 
                                    Si crees que esto es un error, por favor contacta al administrador del sistema.
                                </p>
                                <NavLink 
                                    to="/home" 
                                    className="btn btn-primary"
                                >
                                    Volver al Inicio
                                </NavLink>
                            </div>
                        </div>
                    </div>                        
                </section>
            </div>
        </Fragment>
    );
}

export default Error401Page;
